import { CONFIRM_BOX } from 'features/GlobalConfirmBox/config'
import { DeepPartial, Post, User } from 'lib/_types'

export const toggleConfirmBox = ({
  key,
  data,
  confirmBoxProps,
}: {
  key: string
  data?: any
  confirmBoxProps?: any
}) => ({
  type: 'CONFIRMBOX_TOGGLE',
  payload: {
    key,
    data,
    confirmBoxProps,
  },
})

export const closeConfirmBox = ({ key }) => ({
  type: 'CONFIRMBOX_TOGGLE/CLOSE',
  payload: {
    key,
  },
})

export const toggleUnFollowConfirmBox = ({ user, confirmBoxProps = {} }) => {
  return toggleConfirmBox({
    key: CONFIRM_BOX.UNFOLLOW,
    data: { user },
    confirmBoxProps,
  })
}

export const toggleJoinGroupBeforeActionConfirmBox = (groupId: string) => {
  return toggleConfirmBox({
    key: CONFIRM_BOX.JOIN_GROUP_BEFORE_ACTION,
    data: { groupId },
  })
}

export const toggleDetectBanWordConfirmBox = () => {
  return toggleConfirmBox({
    key: CONFIRM_BOX.DETECT_BAN_WORD,
  })
}

export const toggleVipFeatureConfirmBox = () => {
  return toggleConfirmBox({
    key: CONFIRM_BOX.VIP_FEATURE,
  })
}

export const toggleGroupOwnerTransferConfirmBox = (groupId: string) => {
  return toggleConfirmBox({
    key: CONFIRM_BOX.GROUP_OWNER_TRANSFER,
    data: { groupId },
  })
}

export const toggleGroupModeratorOfferConfirmBox = (groupId: string) => {
  return toggleConfirmBox({
    key: CONFIRM_BOX.GROUP_MODERATOR_OFFER,
    data: { groupId },
  })
}

export const toggleUnPinPostConfirmBox = (data: {
  post: Post
  groupId: string
  onUnpinPostCallback: Function
}) => {
  return toggleConfirmBox({ key: CONFIRM_BOX.UNPIN_POST, data })
}

export const toggleMovePostToThreadConfirmBox = (data: {
  post: Post
  isAddToExistingThreadEnabled: boolean
}) => {
  return toggleConfirmBox({ key: CONFIRM_BOX.MOVE_POST_TO_THREAD, data })
}

export const toggleBlockUserConfirmBox = ({
  user,
  post,
  postIndex,
  returnPath = undefined,
  onClose, // Example of onClose, from `<ReportModal />` that gets called from `<RemoteStream />`.
}: {
  user: Partial<User>
  post?: DeepPartial<Post>
  postIndex?: number
  returnPath?: string
  onClose?: Function
}) => {
  return toggleConfirmBox({
    key: CONFIRM_BOX.BLOCK_USER,
    data: { user, post, postIndex, returnPath, onClose },
  })
}

export const toggleDefaultConfirmBox = ({
  title,
  content,
  confirmBoxProps = {},
}: {
  title?: string
  content?: string
  confirmBoxProps?: Object
}) => {
  return toggleConfirmBox({
    key: CONFIRM_BOX.DEFAULT,
    data: { title, content },
    confirmBoxProps,
  })
}
